import { PortalSelectedLoan } from '../App';

export type LoanOfficerContact = { name?: string; email?: string };

/**
 * Transfer data wins as a pair: once a loan is transferring, the borrower should be pointed at the
 * new servicer's officer rather than the one who originated the loan.
 */
export const getLoanOfficerContact = (
  snapshot: PortalSelectedLoan['currentSnapshot'],
): LoanOfficerContact | undefined => {
  const { originationData, transferData } = snapshot;
  const source = transferData?.loanOfficerName || transferData?.loanOfficerEmail ? transferData : originationData;

  const name = source?.loanOfficerName ?? undefined;
  const email = source?.loanOfficerEmail ?? undefined;

  return name || email ? { name, email } : undefined;
};

export const formatLoanOfficerContact = ({ name, email }: LoanOfficerContact): string =>
  [name, email].filter(Boolean).join(' | ');
